// DEVICE --> Request --> CRS (api/1/devices/heartbeat <--> eu01-stg03-vendor-monitor-heartbeat/api/v1/devices/heartbeat) --> to HBS inside cluster --> received heartbeat
export const HEARTBEAT_URL = 'api/1/devices/heartbeat'; // this is API Gateway
